import { G } from '@mobily/ts-belt';
import DescriptionIcon from '@mui/icons-material/Description';
import { Link as MuiLink } from '@mui/material';
import { useTranslate } from 'react-admin';

import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { useServerExport } from '@sh4res/bo-common/hooks/useServerExport';

interface ExportAllocationsProps {
  campaignId: number | null;
}

export const ExportAllocations: React.FC<ExportAllocationsProps> = ({ campaignId }) => {
  const translate = useTranslate();
  const resourceBasePath = useResourceBasePath();
  const { exportFile, isExporting } = useServerExport();

  if (G.isNullable(campaignId)) {
    return null;
  }

  return (
    <MuiLink
      component="button"
      onClick={async () =>
        exportFile(`${resourceBasePath}campaigns/allocations`, {
          kind: 'campaign_allocations',
          campaign_id: campaignId,
        })
      }
      disabled={isExporting}
      underline="hover"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        cursor: isExporting ? 'default' : 'pointer',
        color: isExporting ? 'text.disabled' : 'primary.main',
        border: 'none',
        background: 'none',
        padding: 0,
        font: 'inherit',
      }}>
      <DescriptionIcon sx={{ fontSize: 20, verticalAlign: 'middle' }} />
      {translate('resources.bo_common.b2b.campaigns.dashboard.allocations.export.label')}
    </MuiLink>
  );
};
